const state = {
  sitesEdited: {},
  regionsEdited: {},
  employeesToUpdate: {},
  allUsers: [],
  editingSites: false,
  newSubscription: {
    regionID: null,
    permissionSetID: null
  }
};
const getters = {
  getEmployeesSitesEdited: state => state.sitesEdited,
  getRegionsEdited: state => state.regionsEdited,
  getEmployeesToUpdate: state => state.employeesToUpdate,
  getAllUsers: state => state.allUsers,
  getAllUsersObj: state => {
    let obj = {}
    for (let user of state.allUsers) {
      obj[user.id] = user
    }
    return obj
  },
  getIsEditingEmployeeSites: state => state.editingSites,
  getNewSubscription: state => state.newSubscription
};
const mutations = {
  setAllUsers(state, data) {
    state.allUsers = data
  },
  addEmployeeSiteEdited(state, employee) {
    state.sitesEdited[employee.site_id] = employee
  },
  removeEmployeeSiteEdited(state, siteId) {
    delete state.sitesEdited[siteId]
  },
  resetEmployeeSiteEdited(state) {
    state.sitesEdited = {}
  },
  addRegionEdited(state, regionID) {
    state.regionsEdited[regionID] = true
  },
  removeRegionEdited(state, regionID) {
    delete state.regionsEdited[regionID]
  },
  resetRegionEdited(state) {
    state.regionsEdited = {}
  },
  setEmployeesToUpdate(state, obj) {
    state.employeesToUpdate = obj
  },
  removeEmployeeToUpdate(state, siteId) {
    delete state.employeesToUpdate[siteId]
  },
  setEditingEmployeeSites(state, bool) {
    state.editingSites = bool
    state.sitesEdited = {}
    state.regionsEdited = {}
  },
  setNewSubscription(state, { regionID, permissionSetID }) {
    state.newSubscription.permissionSetID = permissionSetID
    state.newSubscription.regionID = regionID
  },
}

export default {
  state,
  getters,
  mutations
};